import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ConsultationBlock from '../../components/cta/ConsultationBlock';

export const About = () => {
  useEffect(() => { document.title = "О компании: опыт более 15 лет | Комплекс строй"; }, []);

  const features = [
    { icon: 'bi-patch-check', title: 'Качество', text: 'Соблюдаем ГОСТы и используем проверенные материалы.' },
    { icon: 'bi-clock-history', title: 'Сроки', text: 'Сдаем объекты в точно оговоренное время.' },
    { icon: 'bi-shield-check', title: 'Гарантия', text: 'Предоставляем юридическую гарантию на результат.' },
    { icon: 'bi-people', title: 'Опыт', text: 'Мастера с профильным стажем более 10 лет.' },
  ];

  return (
    <div style={{ paddingTop: 'var(--nav-height)' }}>
      <div className="bg-dark text-white py-5 mb-5">
        <Container className="py-4 text-center">
          <h1 className="display-4 fw-bold mb-3 text-uppercase">О компании</h1>
          <p className="lead opacity-75">Профессионалы в строительстве и благоустройстве с 2010 года.</p>
        </Container>
      </div>

      <Container className="pb-5">
        <Row className="align-items-center mb-5 gy-4">
          <Col lg={6}>
            <h2 className="fw-bold mb-4">Более 15 лет опыта</h2>
            <p className="text-muted fs-5 lh-lg">Мы создаем надежную основу для вашего участка, используя современные технологии и собственный парк техники.</p>
          </Col>
          <Col lg={6}>
            <Row className="g-3 text-center text-uppercase fw-bold">
              <Col xs={6}><div className="p-4 bg-white rounded shadow-sm border-bottom border-4 border-orange"><h3>15+</h3><small className="text-muted">Лет</small></div></Col>
              <Col xs={6}><div className="p-4 bg-white rounded shadow-sm border-bottom border-4 border-orange"><h3>500+</h3><small className="text-muted">Работ</small></div></Col>
            </Row>
          </Col>
        </Row>

        <h3 className="text-center fw-bold mb-5 mt-5">Наши преимущества</h3>
        <Row className="g-4 mb-5">
          {features.map((f, i) => (
            <Col key={i} md={6} lg={3}>
              <Card className="h-100 border-0 shadow-sm p-3 text-center corp-card">
                <Card.Body>
                  <i className={`bi ${f.icon} fs-1 text-accent mb-3 d-block`}></i>
                  <h5 className="fw-bold">{f.title}</h5>
                  <p className="text-muted small mb-0">{f.text}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Блок консультации */}
      <ConsultationBlock />
    </div>
  );
}
